let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iV956")).then(() => parcelRequire('koqy5'));